import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import Grid from "modules/common/components/Grid";
import { ArrowRightIcon } from "styles/icons";
import type { HowScoreIsCalculatedProps, HowScoreIsCalculatedItems } from "./HowScoreIsCalculated.d";

const { Box, Flex, Heading, Text, Link, SimpleGrid } = Chakra;

const HowScoreIsCalculated = ({ items, learnMoreLink }: HowScoreIsCalculatedProps) => {
  const translations = useTranslations();

  return (
    <Grid mb={0} pb={{ base: 4, lg: 8 }} pt={{ base: 14, lg: 24 }}>
      <Box gridColumn={{ base: "span 1", md: "span 12" }} flexDir="column">
        <Flex justifyContent="space-between" flexDir={{ base: "column", lg: "row" }} pb={12}>
          <Heading variant="h2" as="h2" pb={2}>
            {translations("how_is_the_score_calculated")}
          </Heading>
          <Link href={learnMoreLink} pb={3} alignSelf={{ base: "flex-start", lg: "flex-end" }} fontSize="lg">
            {translations("learn_more")} <ArrowRightIcon w="11.77px" h="8.88px" />
          </Link>
        </Flex>
        <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={{ base: 12, lg: 8 }}>
          {items.map((item: HowScoreIsCalculatedItems) => {
            const { header, description, icon: Icon } = item;

            return (
              <Flex key={header} flexDir="column" justifyContent="space-between">
                <Icon h="auto" w={10} mb={6} color="primary.500" />
                <Heading variant="h3" mb={4}>
                  {translations(header)}
                </Heading>
                <Text>{translations(description)}</Text>
              </Flex>
            );
          })}
        </SimpleGrid>
      </Box>
    </Grid>
  );
};

export default HowScoreIsCalculated;
